import { Component, ElementRef, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import config from 'config/default.json';
@Component({
  selector: 'app-vca-student-manager',
  templateUrl: './vca-student-manager.component.html',
  styleUrls: ['./vca-student-manager.component.scss']
})
export class VcaStudentManagerComponent{
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) { }
  platformInfos:{[x: string]: any} = {origin: 'virtualcampus', key: 'vca', root: 'VIRTUALCAMPUS'};
  @Output() inProgress = new EventEmitter<any>();
  @Input() userInfos: { [x:string]: any } = new Map();
  filterData:any = [];
  dataSource:{[x: string]: any}[] = [];
  modes:{ [x:string]: string|number }[] = [];
  pageId = 'student'
  platforms: any[] = [];
  
  
  
  tableData: { [x:string]: string|number }[] = []; 

  ngOnInit(): void { }
  setProgress(data:any){

  }
  sendFilterData(data:any){
    this.filterData = data;
  }

}
